import { useCallback } from 'react'
import { useR2DispatchContext } from '../../../providers/r2Provider/R2Context'

export default function useSetSplitScreenImageGrid() {
  const r2Dispatch = useR2DispatchContext()
  const setSplitScreenImageGrid = useCallback(
    (value) => {
      r2Dispatch({ type: 'SET_SPLIT_SCREEN_IMAGE_GRID', value })
    },
    [r2Dispatch]
  )

  return setSplitScreenImageGrid
}
